// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* top container right */
.displayComponentHomePageRightContainerTop {
    display: flex;
    padding: 1em;
    animation: fadeInGlobal 2s;
    contain: layout;
}

.displayComponentHomePageRightImage1 {
    max-width: 15em;
    position: relative;
    z-index: 2;
    animation: 4s movementLeft ease-in-out infinite;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
}

.displayComponentHomePageRightImage2 {
    transform: rotate(20deg);
    max-width: 13em;
    position: relative;
    z-index: 1;
    left: -50px;
    top: 35px;
    animation: 5s movementLeft ease-in-out infinite;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
}

@keyframes movementLeft {
    0% {
        left: 0px;
        top: 0px;
    }

    50% {
        left: 20px;
        top: 0;
    }

    100% {
        left: 0px;
        top: 0px;
    }
}

@keyframes movementRight {
    0% {
        right: 0px;
        top: 0px;
    }

    50% {
        right: 20px;
        top: 0;
    }

    100% {
        right: 0px;
        top: 0px;
    }
}

@media only screen and (max-width: 540px) {
    .displayComponentHomePageRightImage1 {
        max-width: 10em;
    }

    .displayComponentHomePageRightImage2 {
        max-width: 8em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/displayComponentHomePage/topDisplayRight/topDisplayRight.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,aAAa;IACb,YAAY;IACZ,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,+CAA+C;IAC/C,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,+CAA+C;IAC/C,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI;QACI,SAAS;QACT,QAAQ;IACZ;;IAEA;QACI,UAAU;QACV,MAAM;IACV;;IAEA;QACI,SAAS;QACT,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,MAAM;IACV;;IAEA;QACI,UAAU;QACV,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/* top container right */\n.displayComponentHomePageRightContainerTop {\n    display: flex;\n    padding: 1em;\n    animation: fadeInGlobal 2s;\n    contain: layout;\n}\n\n.displayComponentHomePageRightImage1 {\n    max-width: 15em;\n    position: relative;\n    z-index: 2;\n    animation: 4s movementLeft ease-in-out infinite;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    border-radius: 5px;\n}\n\n.displayComponentHomePageRightImage2 {\n    transform: rotate(20deg);\n    max-width: 13em;\n    position: relative;\n    z-index: 1;\n    left: -50px;\n    top: 35px;\n    animation: 5s movementLeft ease-in-out infinite;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    border-radius: 5px;\n}\n\n@keyframes movementLeft {\n    0% {\n        left: 0px;\n        top: 0px;\n    }\n\n    50% {\n        left: 20px;\n        top: 0;\n    }\n\n    100% {\n        left: 0px;\n        top: 0px;\n    }\n}\n\n@keyframes movementRight {\n    0% {\n        right: 0px;\n        top: 0px;\n    }\n\n    50% {\n        right: 20px;\n        top: 0;\n    }\n\n    100% {\n        right: 0px;\n        top: 0px;\n    }\n}\n\n@media only screen and (max-width: 540px) {\n    .displayComponentHomePageRightImage1 {\n        max-width: 10em;\n    }\n\n    .displayComponentHomePageRightImage2 {\n        max-width: 8em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
